export default function PublicDataApi({ makeRequest, buildRequest }) {
	function getEthnicities() {
		return buildRequest().then((req) => makeRequest(req.get('/api/PublicData/Ethnicities')));
	}

	function getIwiList() {
		return buildRequest().then((req) => makeRequest(req.get('/api/PublicData/Iwi')));
	}

	function getLanguages() {
		return buildRequest().then((req) => makeRequest(req.get('/api/PublicData/Languages')));
	}

	return {
		getEthnicities,
		getIwiList,
		getLanguages,
	};
}
